import About from "@pages/About/About";
import Layout from "@pages/Layout";
import CV from "@pages/CV/CV";
import CertificatPage from "@pages/Certificat/CertificatPage";
import Portfolio from "@pages/Portfolio/Portfolio";
import ErrorFallback from "@routes/ErrorFallback";
import NotFound from "@routes/NotFound";

export const MAIN_ROUTES = {
  path: "/",
  element: <Layout />,
  // Un seul errorElement : il couvre la route parente et toutes ses enfants.
  errorElement: <ErrorFallback />,
  children: [
    { index: true, element: <About /> },
    { path: "about", element: <About /> },
    { path: "resume", element: <CV /> },
    { path: "certificats", element: <CertificatPage /> },
    { path: "portfolio", element: <Portfolio /> },
    { path: "*", element: <NotFound /> },
  ],
};
